import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditogoacab() {



    const cardData = {





keyword: "Shirdi to Goa Cab",

headingDescription: "Sai Shirdi Cab offers comfortable and reliable Shirdi to Goa Cab service for families, couples, tourists, devotees, and groups traveling from Shirdi to Goa for holidays, beach vacations, family trips, and leisure travel. Customers can book a private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way journeys, round trips, multi-day vacations, and customized travel plans. The spacious vehicles provide a convenient option for travelers carrying luggage on the long road journey from Shirdi to Goa. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup timings, and convenient hotel or destination drops, Sai Shirdi Cab makes long-distance travel easier to organize. Customers can also customize the journey with suitable breaks and include popular destinations in Maharashtra or Goa according to their holiday itinerary.",

topPlaces: [
  {
    title: "Goa",
    description: "Goa is the main destination for this long-distance journey and is popular for its beaches, coastal scenery, historic churches, forts, markets, and vibrant holiday atmosphere. Travelers from Shirdi can book a private cab directly to their hotel, resort, beach area, or preferred destination. One-way and round-trip options are suitable for families and groups."
  },
  {
    title: "Panaji",
    description: "Panaji is the capital city of Goa and offers colorful neighborhoods, heritage architecture, riverfront views, churches, and convenient access to nearby attractions. Travelers from Shirdi can arrange a private cab for direct transportation to hotels or sightseeing locations. The journey can be customized according to the group's holiday schedule."
  },
  {
    title: "Calangute",
    description: "Calangute is one of Goa's well-known beach destinations and attracts families, couples, and tourists throughout the year. Travelers can book a private cab from Shirdi for a comfortable road journey directly to their accommodation. Customers can also include nearby North Goa beaches and attractions in their customized travel itinerary."
  },
  {
    title: "Baga",
    description: "Baga is a popular North Goa destination known for its beach, restaurants, entertainment, and lively holiday atmosphere. A private cab provides convenient transportation for travelers arriving from Shirdi with luggage and family belongings. Customers can plan direct hotel drops or combine Baga with other Goa sightseeing locations."
  },
  {
    title: "Margao",
    description: "Margao is an important commercial and cultural city in South Goa and provides access to several nearby beaches and attractions. Travelers from Shirdi can choose a private cab for direct transportation to hotels, residences, or other destinations. The service is suitable for families and groups planning longer Goa vacations."
  },
  {
    title: "Vasco da Gama",
    description: "Vasco da Gama is an important city in Goa and is convenient for travelers visiting the region for business, family trips, or airport connections. Customers can book a private cab from Shirdi for a direct long-distance journey. Comfortable vehicles with sufficient luggage space are suitable for extended road travel."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a popular coastal destination in Karnataka known for its beaches, temples, and relaxed atmosphere. Travelers extending their Shirdi to Goa journey can include Gokarna in a customized coastal holiday itinerary. Private cab travel provides flexibility for families and groups wanting to explore multiple destinations."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important religious and cultural city in Maharashtra and can be included as a stop during a longer road journey toward Goa. Travelers can visit the Mahalaxmi Temple and other local attractions before continuing their holiday. Sai Shirdi Cab provides private vehicles suitable for families and groups with luggage."
  },
  {
    title: "Belgaum",
    description: "Belgaum, also known as Belagavi, is an important city in Karnataka located along the broader travel corridor toward Goa. Travelers can include the city as a convenient stop for family visits, business travel, or sightseeing. Private cab service allows customers to customize their route and travel schedule."
  },
  {
    title: "Dudhsagar",
    description: "Dudhsagar is one of the most famous natural attractions associated with Goa and is known for its impressive waterfall and forest surroundings. Travelers planning a Goa sightseeing vacation can include the Dudhsagar region in their itinerary. A private cab provides convenient transportation to suitable access points and nearby destinations."
  },
  {
    title: "Ponda",
    description: "Ponda is an important inland destination in Goa known for temples, greenery, and cultural attractions. Travelers can include Ponda while exploring destinations beyond the beaches during their holiday from Shirdi. Private cab service makes it easier to create a customized Goa sightseeing route with flexible stops."
  },
  {
    title: "Old Goa",
    description: "Old Goa is a major heritage destination known for historic churches and Portuguese-era architecture. Travelers from Shirdi can include Old Goa in their sightseeing itinerary after reaching the state. A private cab allows families and groups to comfortably travel between their accommodation and important heritage attractions."
  }
],




  "services": [
    {
      "name": "Shirdi to Goa Cab Service",
      "description": "Shirdi to Goa Cab Service provides a convenient private travel option for passengers planning a comfortable journey from Shirdi to Goa. Cab arrangements can be selected according to the number of passengers, luggage, preferred vehicle type, and one-way or return travel requirements."
    },
    {
      "name": "Shirdi to Goa Cab Package",
      "description": "Shirdi to Goa Cab Package is suitable for travelers looking for organized transportation between Shirdi and Goa. The package can be planned for direct travel, sightseeing stops, family trips, group journeys, and return schedules with a suitable private vehicle."
    },
    {
      "name": "Shirdi to Goa Innova Cab Packages",
      "description": "Shirdi to Goa Innova Cab Packages offer spacious private transportation for families and small groups traveling on the long-distance route. An Innova can provide comfortable seating and luggage space while the itinerary can be arranged according to the required pickup, route, and destination."
    },
    {
      "name": "Shirdi to Goa Innova Crysta Cab",
      "description": "Shirdi to Goa Innova Crysta Cab is a comfortable option for travelers who prefer a premium vehicle for their intercity journey. The spacious cabin is suitable for families and groups, with cab arrangements available for one-way trips, return journeys, and customized travel plans."
    },
    {
      "name": "Shirdi to Goa Tempo Traveller on Rental",
      "description": "Shirdi to Goa Tempo Traveller on Rental is designed for larger families and groups requiring additional seating capacity. The vehicle can be arranged for group travel from Shirdi to Goa with convenient pickup, luggage space, and an itinerary planned around the group's travel requirements."
    },
    {
      "name": "Shirdi to Goa Cab Booking",
      "description": "Shirdi to Goa Cab Booking allows travelers to arrange private transportation for their journey from Shirdi to Goa in advance. Customers can select a suitable vehicle category and plan pickup details, travel dates, passenger requirements, and one-way or round-trip transportation."
    },
    {
      "name": "Taxi Fare from Shirdi to Goa",
      "description": "Taxi Fare from Shirdi to Goa can vary according to the selected vehicle, trip type, travel distance, and itinerary requirements. Travelers can choose from different cab categories and request a suitable fare option based on one-way, return, or customized travel arrangements."
    },
    {
      "name": "One-Way Cab from Shirdi to Goa",
      "description": "One-Way Cab from Shirdi to Goa is convenient for passengers who need direct transportation without booking a return journey. Private cabs can be arranged from the selected pickup point in Shirdi to the preferred destination in Goa with suitable vehicle options."
    },
    {
      "name": "Round Trip Cab from Shirdi to Goa",
      "description": "Round Trip Cab from Shirdi to Goa provides private transportation for travelers planning to visit Goa and return to Shirdi. The journey can be scheduled according to the required travel dates, stay duration, passenger count, vehicle category, and preferred return itinerary."
    },
    {
      "name": "Shirdi to Goa Distance by Cab Fare",
      "description": "Shirdi to Goa Distance by Cab Fare depends on the route, vehicle category, trip type, and additional travel requirements. Travelers can select a sedan, SUV, Innova, Innova Crysta, or larger vehicle and plan the journey according to their preferred route and schedule."
    },
    {
      "name": "Cheap Cab from Shirdi to Goa",
      "description": "Cheap Cab from Shirdi to Goa provides a practical transportation option for passengers looking to manage their travel budget. Affordable vehicle categories can be selected according to passenger capacity, luggage requirements, one-way travel, or return trip preferences."
    },
    {
      "name": "Best Cab Service from Shirdi to Goa",
      "description": "Best Cab Service from Shirdi to Goa offers private transportation for travelers seeking a comfortable and convenient long-distance journey. Vehicle options can be selected for individuals, families, and groups, with flexible pickup and destination arrangements."
    },
    {
      "name": "Taxi Service from Shirdi to Goa",
      "description": "Taxi Service from Shirdi to Goa provides direct private transportation for passengers traveling between the two destinations. Cab options can be arranged according to the number of travelers, luggage requirements, preferred vehicle, travel date, and one-way or round-trip itinerary."
    },
    {
      "name": "Shirdi to Goa Taxi Service Affordable Rate",
      "description": "Shirdi to Goa Taxi Service Affordable Rate is suitable for travelers comparing practical cab options for a long-distance journey. Customers can select an appropriate vehicle and request a travel plan based on passenger capacity, trip type, pickup location, and destination."
    },
    {
      "name": "Shirdi Airport to Goa Taxi",
      "description": "Shirdi Airport to Goa Taxi provides private airport transfer transportation for passengers traveling from Shirdi Airport toward Goa. The service can be arranged with suitable vehicles for individuals, families, and groups according to luggage, seating, and destination requirements."
    },
    {
      "name": "Shirdi to Goa Cabs",
      "description": "Shirdi to Goa Cabs provide convenient private transportation for travelers planning an intercity journey between Shirdi and Goa. Sedan, SUV, Innova, Innova Crysta, and larger group vehicles can be selected according to passenger requirements and travel plans."
    },
    {
      "name": "Fast and Affordable Taxi Service",
      "description": "Fast and Affordable Taxi Service provides a practical travel option for passengers looking for convenient transportation between Shirdi and Goa. Cab arrangements can be planned around the preferred pickup time, vehicle category, passenger count, luggage, and one-way or return journey."
    },
    {
      "name": "Shirdi to Goa Taxi Service Affordable Rate Price",
      "description": "Shirdi to Goa Taxi Service Affordable Rate Price helps travelers choose a suitable private cab according to their budget and travel requirements. The final fare can depend on the selected vehicle, journey type, route, passenger capacity, and additional stops included in the itinerary."
    }
  ],
  "tableData": [
    ["Shirdi to Goa Cab Service", "Shirdi to Goa Cab Package"],
    ["Shirdi to Goa Innova Cab Packages", "Shirdi to Goa Innova Crysta Cab"],
    ["Shirdi to Goa Tempo Traveller on Rental", "Shirdi to Goa Cab Booking"],
    ["Taxi Fare from Shirdi to Goa", "One-Way Cab from Shirdi to Goa"],
    ["Round Trip Cab from Shirdi to Goa", "Shirdi to Goa Distance by Cab Fare"],
    ["Cheap Cab from Shirdi to Goa", "Best Cab Service from Shirdi to Goa"],
    ["Taxi Service from Shirdi to Goa", "Shirdi to Goa Taxi Service Affordable Rate"],
    ["Shirdi Airport to Goa Taxi", "Shirdi to Goa Cabs"],
    ["Fast and Affordable Taxi Service", "Shirdi to Goa Taxi Service Affordable Rate Price"]
  ],















        whychoose: [
            { 
                WhyChooseheading: "Nashik Airport to Shirdi Cab for Pilgrimage Transfers", 
                WhyChoosedescription: "Sai Shirdi Cabs offers private taxi transportation from Nashik Airport to Shirdi for devotees, families, tourists, senior citizens, and business travellers. A dedicated cab provides direct airport-to-Shirdi travel with space for passengers and their luggage." 
            }, 
            { 
                WhyChooseheading: "Airport Pickup Based on Your Flight Schedule", 
                WhyChoosedescription: "Share your Nashik Airport arrival details while booking so the pickup can be planned around your flight schedule. Passengers can continue towards Shirdi after landing without arranging separate local transportation." 
            }, 
            { 
                WhyChooseheading: "Direct Travel Towards Sai Baba Temple", 
                WhyChoosedescription: "Devotees arriving at Nashik Airport can travel directly towards Shirdi and their preferred hotel or destination near Sai Baba Temple. The private transfer avoids the inconvenience of changing vehicles during the journey." 
            }, 
            { 
                WhyChooseheading: "Comfortable Option for Family Pilgrimages", 
                WhyChoosedescription: "Families travelling with children, senior citizens, and pilgrimage luggage can select a suitable cab according to their group size. Having a dedicated vehicle allows everyone to travel together from the airport to Shirdi." 
            }, 
            { 
                WhyChooseheading: "Useful for Sai Baba Darshan Planning", 
                WhyChoosedescription: "Travellers can coordinate their airport arrival and Shirdi visit around their Darshan plans. A private cab provides flexibility to continue towards the pilgrimage destination after completing the airport transfer." 
            }, 
            { 
                WhyChooseheading: "One-Way Airport Drop to Shirdi", 
                WhyChoosedescription: "Passengers who only require transportation from Nashik Airport to Shirdi can choose a one-way cab. This is suitable when separate arrangements have already been made for local travel or the return journey." 
            }, 
            { 
                WhyChooseheading: "Vehicle Options for Different Group Sizes", 
                WhyChoosedescription: "Cab options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage quantity, and preferred comfort level for the airport transfer." 
            }, 
            { 
                WhyChooseheading: "Book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs", 
                WhyChoosedescription: "Provide your Nashik Airport arrival details, pickup information, Shirdi destination, travel date, passenger count, luggage requirements, and preferred vehicle to Sai Shirdi Cabs for a suitable private airport cab arrangement." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a cab from Nashik Airport to Shirdi?", 
            answer: "Yes, Sai Shirdi Cabs provides private cab services from Nashik Airport to Shirdi for devotees, families, tourists, senior citizens, and other travellers." 
        }, 
        { 
            question: "Can I get pickup from Nashik Airport after my flight arrives?", 
            answer: "Yes, passengers can arrange airport pickup by sharing their flight details and expected arrival information during the booking process." 
        }, 
        { 
            question: "Can I travel directly from Nashik Airport to Shirdi?", 
            answer: "Yes, a private cab provides direct transportation from Nashik Airport to Shirdi, allowing passengers to continue their journey without arranging multiple connecting vehicles." 
        }, 
        { 
            question: "Is Nashik Airport to Shirdi Cab suitable for Sai Baba Darshan?", 
            answer: "Yes, the service is suitable for devotees arriving at Nashik Airport and travelling to Shirdi for Sai Baba Darshan and other pilgrimage activities." 
        }, 
        { 
            question: "Can families book a taxi from Nashik Airport to Shirdi?", 
            answer: "Yes, families can select a suitable vehicle according to passenger count, luggage requirements, and preferred comfort level for the airport-to-Shirdi journey." 
        }, 
        { 
            question: "Do you provide one-way Nashik Airport to Shirdi Cab service?", 
            answer: "Yes, one-way cab service is available for passengers who need direct transportation from Nashik Airport to Shirdi without requiring the same vehicle for the return journey." 
        }, 
        { 
            question: "Can I book a return cab from Shirdi to Nashik Airport?", 
            answer: "Yes, return transportation can be discussed for passengers who need to travel from Shirdi back towards Nashik Airport after completing their pilgrimage or stay." 
        }, 
        { 
            question: "Which vehicles are available for Nashik Airport to Shirdi travel?", 
            answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and travel requirements." 
        }, 
        { 
            question: "Can I carry luggage from Nashik Airport to Shirdi?", 
            answer: "Yes, passengers can carry airport luggage according to the available storage capacity of the selected vehicle. Bulky or additional baggage should be mentioned during booking." 
        }, 
        { 
            question: "How can I book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs?", 
            answer: "Share your flight details, Nashik Airport arrival time, Shirdi destination, travel date, passenger information, luggage requirements, and preferred vehicle with Sai Shirdi Cabs to proceed with the cab booking." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Prakash Gaikwad", 
            feedback: "We landed at Nashik Airport and needed to continue to Shirdi with our family. The private cab was convenient because we could travel directly with our luggage and avoid changing vehicles.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Meena Joshi", 
            feedback: "Our Shirdi pilgrimage started after arriving at Nashik Airport. We booked a private taxi for the transfer and found it much easier to travel together with our parents and bags.", 
            rating: 5 
        } 
    ];




    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Goa Cab on Rent",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-goa-cab-on-rent.webp",
  "description":
    "Book Shirdi to Goa Cab on Rent with Sai Shirdi Cabs for a safe, comfortable, and reliable long-distance journey. We provide one-way, round-trip, and customized cab packages from Shirdi to Goa for family vacations, group trips, sightseeing, and holiday travel. Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller options with professional drivers, convenient pickup and drop, flexible packages, and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-goa-cab-on-rent"
  }
};





    return (
        <div>

<Helmet>
  <title>Shirdi to Goa Cab on Rent | Goa Taxi Service | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Goa Cab on Rent with Sai Shirdi Cabs for affordable one-way, round-trip and customized cab packages. Hire Innova, Innova Crysta, Sedan, Ertiga and Tempo Traveller from Shirdi to Goa with professional drivers and comfortable long-distance travel."
  />

  <meta
    name="keywords"
    content="Shirdi to Goa Cab on Rent, Shirdi to Goa Cab Service, Shirdi to Goa Cab Package, Shirdi to Goa Innova Cab Packages, Shirdi to Goa Innova Crysta Cab, Shirdi to Goa Tempo Traveller on Rental, Shirdi to Goa Cab Booking, Taxi Fare from Shirdi to Goa, One-Way Cab from Shirdi to Goa, Round Trip Cab from Shirdi to Goa, Shirdi to Goa Distance by Cab Fare, Cheap Cab Shirdi to Goa, Shirdi to Goa Taxi, Shirdi to Goa Taxi Fare, Shirdi to Goa Cab Fare, Shirdi to Goa One Way Taxi, Shirdi to Goa Round Trip Taxi, Shirdi to Goa Car Rental, Shirdi to Goa Car Hire, Shirdi to Goa Travel Service, Shirdi Goa Cab, Shirdi Goa Taxi Service, Goa to Shirdi Cab, Goa to Shirdi Taxi, Goa to Shirdi Cab Service, Goa to Shirdi One Way Cab, Goa to Shirdi Round Trip Taxi, Shirdi to Goa Online Cab Booking, Shirdi to Goa Affordable Cab, Best Shirdi to Goa Taxi Service, Reliable Shirdi to Goa Cab, Shirdi to Goa Innova Rental, Shirdi to Goa Innova Crysta on Rent, Shirdi to Goa Ertiga Cab, Shirdi to Goa Sedan Cab, Shirdi to Goa Tempo Traveller Rental, Shirdi to Goa Tempo Traveller Cab, Shirdi to Goa Family Cab, Shirdi to Goa Group Cab, Shirdi to Goa Holiday Package, Shirdi to Goa Tour Package, Shirdi to Goa Vacation Cab, Shirdi to Goa Sightseeing Taxi, Shirdi to Goa Private Cab, Shirdi to Goa Outstation Taxi, Shirdi to Goa Long Distance Cab, Shirdi to Goa Round Trip Package, Shirdi to Goa One Way Cab Booking, Shirdi to Goa Taxi Booking, Shirdi to Goa Cab Rental, Shirdi to Goa Cab Hire, Affordable Shirdi to Goa Cab, Cheap Shirdi to Goa Taxi, Best Cab from Shirdi to Goa, Goa Trip from Shirdi by Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditogoacab;